import i18n from "../i18n";
import aemMenu from './aemMenu';
export const getLanguagePaths = () => {
  // le url sono:
  // relative, se si punta al portale pubblico, e in quel caso il dominio viene poi aggiunto dalla funzione helpers/getCorrectLink
  // assolute se puntanti all'esterno del portale
  // per ora questo file è statico, ma va reso dinamico da aem, ci deve passare la loro struttura menu,
  // quantomeno la parte relativa in tutte le lingue

  return {
    'investor-relations': {
      'it-IT': '/it/investor-relations',
      'en-EN': '/en/investor-relations',
    },
    'fornitori-e-gare_header': {
      'it-IT': 'https://acquisti.gruppocap.it/web/default.shtml',
      'en-EN': 'https://acquisti.gruppocap.it/web/default.shtml',
    },
    'fornitori-e-gare_footer': {
      'it-IT': '/it/fornitori-e-gare',
      'en-EN': '/en/suppliers-and-tenders',
    },
    'lavora-con-noi': {
      'it-IT': '/it/lavora-con-noi',
      'en-EN': '/en/work-with-us'
    },

    'area-riservata': {
      'it-IT': '/area-riservata/',
      'en-EN': '/area-riservata/',
    },

    'il-gruppo': {
      'it-IT': '/it/il-gruppo',
      'en-EN': '/en/the-group',
    },
    'servizi-per-i-cittadini': {
      'it-IT': '/it/servizi-per-i-cittadini',
      'en-EN': '/en/services-for-citizens',
    },
    'cosa-facciamo': {
      'it-IT': '/it/cosa-facciamo',
      'en-EN': '/en/what-we-do',
    },
    'sviluppo-e-sostenibilita': {
      'it-IT': '/it/sviluppo-e-sostenibilita',
      'en-EN': '/en/development-and-sustainability',
    },
    'media-e-comunicazione': {
      'it-IT': '/it/media-e-comunicazione',
      'en-EN': '/en/media-and-communication',
    },
    'pronto-intervento': {
      'it-IT': '/it/pronto-intervento',
      'en-EN': '/en/emergency-service',
    },

    'contatti': {
      'it-IT': '/it/contatti',
      'en-EN': '/en/contacts'
    },

    'documenti-e-siti-utili': {
      'it-IT': '/it/documenti-e-siti-utili',
      'en-EN': '/en/useful-documents-and-sites',
    },

    'le-nostre-policies': {
      'it-IT': '/it/le-nostre-policies',
      'en-EN': '/en/le-nostre-policies',
    },
    'cookie-policy': {
      'it-IT': '/it/cookie-policy',
      'en-EN': '/en/cookie-policy',
    },
    'note-legali': {
      'it-IT': '/it/note-legali',
      'en-EN': '/en/legal-notes',
    },
    'accesso-dipendenti': {
      'it-IT': "/it",
      'en-EN': "/en",
    },
    'accesso-soci': {
      'it-IT': '/area-riservata/',
      'en-EN': '/area-riservata/',
    },
    'sitemap': {
      'it-IT': '/it/sitemap.xml',
      'en-EN': '/en/sitemap.xml',
    },
    'dpo': {
      'it-IT': '/it/dpo',
      'en-EN': '/en/dpo',
    },
    'home': {
      'it-IT': '/it',
      'en-EN': '/en',
    },
    'cap-holding-governance': {
      'it-IT': '/it/il-gruppo/governance/cap-holding',
      'en-EN': '/en/the-group/governance/cap-holding',
    },
    // nota di Valentino: guarda che questa chiave è uguale alla 'servizi-per-i-cittadini'
    'view-cases-hero-description-link': {
      'it-IT': '/it/servizi-per-i-cittadini',
      'en-EN': '/en/services-for-citizens',
    },
    'facebook': {
      'it-IT': 'https://www.facebook.com/GruppoCAP',
      'en-EN': 'https://www.facebook.com/GruppoCAP',
    },
    'instagram': {
      'it-IT': 'https://www.instagram.com/gruppocap/',
      'en-EN': 'https://www.instagram.com/gruppocap/',
    },
    'twitter': {
      'it-IT': 'https://twitter.com/gruppocap?_',
      'en-EN': 'https://twitter.com/gruppocap?_',
    },
    'youtube': {
      'it-IT': 'https://www.youtube.com/user/CAPholding',
      'en-EN': 'https://www.youtube.com/user/CAPholding',
    },
    'linkedin': {
      'it-IT': 'https://www.linkedin.com/company/gruppo-cap/',
      'en-EN': 'https://www.linkedin.com/company/gruppo-cap/',
    },
    'pdf-informativa-sportello': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/informativa%20sportello%20online.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/informativa%20sportello%20online.pdf',
    },
    'pdf-domanda-disdetta': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/07_domanda%20disdetta.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/07_domanda%20disdetta.pdf',
    },
    'pdf-modulo-sepa': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/MODULO%20SEPA.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/MODULO%20SEPA.pdf',
    },
    'cases-info-voltura': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/Descrizione%20Procedura%20Wizard%20Voltura.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/Descrizione%20Procedura%20Wizard%20Voltura.pdf',
    },
    'cases-info-subentro': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/Descrizione%20Procedura%20Wizard%20Subentro.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/Descrizione%20Procedura%20Wizard%20Subentro.pdf',
    },
    'cases-info-allacciamento': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/Descrizione%20Procedura%20Wizard%20Allacciamento.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/Descrizione%20Procedura%20Wizard%20Allacciamento.pdf',
    },
    'cases-info-fognatura': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/Descrizione%20Procedura%20Wizard%20Allacciamento.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/Descrizione%20Procedura%20Wizard%20Allacciamento.pdf',
    },
    'tracciamento-nuove-reti': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/tracciamento-reti/RTRI%20-%20Richiesta%20di%20tracciamento%20in%20campo%20delle%20reti%20rev.%200.docx',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/tracciamento-reti/RTRI%20-%20Richiesta%20di%20tracciamento%20in%20campo%20delle%20reti%20rev.%200.docx',
    },
    'pdf-regolamento-del-servizi-idrico': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/REGOLAMENTO%20DEL%20SERVIZIO%20IDRICO.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/REGOLAMENTO%20DEL%20SERVIZIO%20IDRICO.pdf',
    },
    'pdf-elenco-prezzi': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Elenco%20prezzi%20all%27utenza.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Elenco%20prezzi%20all%27utenza.pdf',
    },
    'pdf-asseverazione-dei-contenuti': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Check%20list%20di%20asseverazione%20dei%20contenuti%20del%20progetto%20esecutivo%20%20in%20riferimento%20al%20D.Lgs.%208108.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Check%20list%20di%20asseverazione%20dei%20contenuti%20del%20progetto%20esecutivo%20%20in%20riferimento%20al%20D.Lgs.%208108.pdf'
    },
    'pdf-richiesta-di-parere-tecnico': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Richiesta%20di%20parere%20tecnico%20preventivo.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Richiesta%20di%20parere%20tecnico%20preventivo.pdf',
    },
    'zip-specifiche-as-build': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Specifiche%20As-Built_Rev.%200.zip',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Specifiche%20As-Built_Rev.%200.zip',
    },
    'zip-specifiche-as-build-2019': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/SPECIFICHE%20AS%20BUILT_2019.zip',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/SPECIFICHE%20AS%20BUILT_2019.zip',
    },
    'pdf-tariffario': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Tariffario.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/opere-di-urbanizzazione-pareri-e-collaudi/Tariffario.pdf',
    },
    'pdf-allegato-sicurezza': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-web/servizi-per-i-cittadini/Check%20list%20di%20asseverazione%20dei%20contenuti%20del%20progetto%20esecutivo%20%20in%20riferimento%20al%20D.Lgs.%208108.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-web/servizi-per-i-cittadini/Check%20list%20di%20asseverazione%20dei%20contenuti%20del%20progetto%20esecutivo%20%20in%20riferimento%20al%20D.Lgs.%208108.pdf',
    },
    'link-what-we-do': {
      'it-IT': '/it/cosa-facciamo/mappe-e-cantieri',
      'en-EN': '/it/cosa-facciamo/mappe-e-cantieri'
    },
    'link-invarianza-idraulica': {
      'it-IT': '/it/cosa-facciamo/territorio-e-resilienza/invarianza-idraulica',
      'en-EN': '/it/cosa-facciamo/territorio-e-resilienza/invarianza-idraulica'
    },
    'documento-informatica': {
      'it-IT': '/content/dam/groupcap/assets/documents/documents-personal-area/Informativa%20utenze%20indirette%20Arera_rev301122.pdf',
      'en-EN': '/content/dam/groupcap/assets/documents/documents-personal-area/Informativa%20utenze%20indirette%20Arera_rev301122.pdf'
    },
    'accessibilita': {
      'it-IT': '/it/accessibilita',
      'en-EN': '/it/accessibilita'
    }
  }
}


const getMenuConfig = () => {
  const {language} = i18n;

  const languagePaths = getLanguagePaths();
  return {
    topMenuLinks: aemMenu.get(language,'topMenuLinks'),
    menuLinks: aemMenu.get(language,'menuLinks'),
    footerLinks: aemMenu.get(language,'footerLinks'),
    footerAdditionalIcons: aemMenu.get(language,'footerAdditionalIcons'),
    socialLinks: aemMenu.get(language,'socialLinks'),
    copyright:aemMenu.get(language,'copyright'),
    cutoverBanner:aemMenu.get(language,'cutoverBanner'),
    chatbotInfo:aemMenu.get(language,'chatbotInfo'),
    home: languagePaths['home'][language],
    viewCases: languagePaths['view-cases-hero-description-link'][language],
    tracciamentoNuoveReti: languagePaths['tracciamento-nuove-reti'][language],
    opereDiUrbanizzazione: {
      pdf: {
        'regolamentoDelServiziIdrico': languagePaths['pdf-regolamento-del-servizi-idrico'][language],
        'elencoPrezzi': languagePaths['pdf-elenco-prezzi'][language],
        'richiestaDiParereTecnico': languagePaths['pdf-richiesta-di-parere-tecnico'][language],
        'tariffario': languagePaths['pdf-tariffario'][language],
        'asseverazioneDeiContenuti': languagePaths['pdf-asseverazione-dei-contenuti'][language],
        'allegatoSicurezza':languagePaths['pdf-allegato-sicurezza'][language],
      },
      zip: {
        'specificheAsBuild': languagePaths['zip-specifiche-as-build'][language],
        'specificheAsBuild2019': languagePaths['zip-specifiche-as-build-2019'][language],
      },
      url: {
        'whatWeDo': languagePaths['link-what-we-do'][language],
        'invarianzaIdraulica': languagePaths['link-invarianza-idraulica'][language],
        'documentiUtilili': languagePaths['documenti-e-siti-utili'][language],
      }
    },
    pdfLinks: {
      'pdfInformativaSportello': languagePaths['pdf-informativa-sportello'][language],
      'pdfDomandaDisdetta': languagePaths['pdf-domanda-disdetta'][language],
      'pdfModuloSepa': languagePaths['pdf-modulo-sepa'][language],
      'casesInfoVoltura': languagePaths['cases-info-voltura'][language],
      'casesInfoSubentro': languagePaths['cases-info-subentro'][language],
      'casesInfoAllacciamento': languagePaths['cases-info-allacciamento'][language],
      'casesInfoFognatura': languagePaths['cases-info-fognatura'][language],
      'aggiornaPrivacy':languagePaths['documento-informatica'][language],
    }
  }
};

export default getMenuConfig;
